import request from "@utils/request";

export function getLoginHistory(query) {
    return request({
        url: "login/history",
        method: "get",
        params: query
    });
}
